import { render, staticRenderFns } from "./OutlineEditor.vue?vue&type=template&id=bda2af1e&"
import script from "./OutlineEditor.vue?vue&type=script&lang=ts&"
export * from "./OutlineEditor.vue?vue&type=script&lang=ts&"
import style0 from "./OutlineEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports